import { createAction, props } from '@ngrx/store';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { FaxFilterOptions } from '../../models/fax-filter-option';
import { FaxRegisterListItem } from '../../models/fax-register-results.model';

const area = 'Outgoing Fax Register';
export const outgoingFaxRegisterAdapterActions = createRegisterActions<FaxRegisterListItem>(area);

export const createfax = createAction(`[${area}] Create fax`);

export const outgoingFaxRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: FaxFilterOptions[]; quickFilters: any }>()
);

export const openDialog = createAction(`[${area}] Open Dialog`, props<{ faxLogs: any }>());
